export enum Model {
  User = 'user',
  Patient = 'patient',
  CP = 'CP'
}

// enum for application-specific error codes from the backend
export enum AppErrorCodes {
  SITE_INACTIVATION_ERROR = 104,
  ACTIVATION_ERROR = 111
}

export const ErrorMessages = {
  [AppErrorCodes.SITE_INACTIVATION_ERROR]: (data: {
    activeUsers: number;
    activePatients: number;
    activeCps: number;
  }) => {
    const { activeUsers, activePatients, activeCps } = data;
    return `Site cannot be inactivated - site has active patients (${activePatients}), users (${activeUsers}) , CPs (${activeCps}).`;
  },
  [AppErrorCodes.ACTIVATION_ERROR]: (model: Model) =>
    `This ${model} is assigned to an inactive site and therefore cannot be activated.`
};
